export default "__VITE_ASSET__ee3b7f46__"